import React, { ReactElement } from "react";
import '../../scss/components/NavigateConfirmModal.scss';
import Button from "../Form/Button.tsx";

const NavigateConfirmModal = ({
    setterCallback,
    proceed,
    text,
    leaveText,
    cancelText = 'Abbrechen',
}:{
    setterCallback:Function,
    proceed: Function,
    text: ReactElement,
    leaveText: string,
    cancelText?: string,
}) => {

    return (
        <div className='navigate-confirm-modal'>
            <div className="modal-inner" role="dialog" aria-modal="true">
                { text }
                <div className="row justify-content-center align-items-center wrap">
                    <Button buttonType='outline' icon="x" onClick={()=>{setterCallback(false)}}>{cancelText}</Button>
                    <Button buttonType='primary' icon="arrow" onClick={proceed}>{leaveText}</Button>
                </div>
            </div>
        </div>
    )
}

export default NavigateConfirmModal;